import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'

/** 行内折叠：替代 <details>，默认收起 */
export function Disclosure({ summary, children, className }) {
  return (
    <Accordion type="single" collapsible className={className}>
      <AccordionItem value="item" className="border-0">
        <AccordionTrigger className="justify-start gap-2 py-0 text-left font-normal hover:underline">
          {summary}
        </AccordionTrigger>
        <AccordionContent className="pb-0 pt-2">{children}</AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}
